export const filterButtons = (activeButton) => [
  {
    disabled: activeButton === 'filter',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'filter',
    text: 'По фильтрам',
  },
  {
    disabled: activeButton === 'brems',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'brems',
    text: 'По колодкам',
  },
  {
    disabled: activeButton === 'wiperblade',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'wiperblade',
    text: 'По щеткам',
  },
];
